import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

export default class {
  // Set inital vars
  constructor(el) {
    this.el = el;
    this.blockId = el.getAttribute('data-block-id')
  }

  // Initilize Module
  init() {
    this.ContentCarousel();
  }

  ContentCarousel() {

    const scope = this;
    this.slider = new Swiper(this.el.querySelector('.swiper-container'), {
      slidesPerView: 1,
      autoHeight: false,
      loop: false,
      speed: 600,
      direction: 'horizontal',

      pagination: {
        el: `.swiper-pagination${this.blockId}`,
        clickable: true,
      },

      navigation: {
        nextEl: `.swiper-next-${this.blockId}`,
        prevEl: `.swiper-previous-${this.blockId}`
      },

      mousewheel: {
        invert: true,
      }
    }).on('slideChange', function() {
      const videos = scope.el.querySelectorAll('video');

      videos.forEach(function(video) {
        video.pause();
        video.currentTime = 0;
        let v = video.currentSrc;
        video.src = '';
        video.src = v;
      })

     });
  }
}
